/**
 * File feature-banner.js
 *
 * Creates parallax scrolling effect
 */

( function ( $ ) {
	// init controller
	const controller = new ScrollMagic.Controller();
	// build scenes
	const revealElements = document.getElementsByClassName(
		'sticky-banner-content'
	);

	for ( let i = 0; i < revealElements.length; i++ ) {
		// create a scene for each element
		new ScrollMagic.Scene( {
			triggerElement: revealElements[ i ], // y value not modified, so we can use element as trigger as well
			offset: 50, // start a little later
			triggerHook: 1,
		} )
			.setClassToggle(
				'[data-sceneid="' + revealElements[ i ].dataset.sceneid + '"]',
				'visibles'
			)
			.on( 'enter leave', function () {
				const $activeSlide = $(
					'.sticky-banner-slide-graphic-item.visibles'
				)
					.last()
					.attr( 'data-sceneid' );

				$( '.sticky-banner-slide-graphic' ).attr(
					'data-slide',
					$activeSlide
				);
			} )
			.addTo( controller );
	}
} )( jQuery );
